/**
 * Inspired by this algorithm : <a href="https://stackoverflow.com/questions/53059358/java-allow-custom-constraint-to-be-null">Implementation details</a>
 * <br/>
 * Compliant version with the specification described here : <a href="https://es.wikipedia.org/wiki/C%C3%B3digo_de_identificaci%C3%B3n_fiscal">Spec</a>
 *
 * Translated from Java (tech-starters/validation/src/main/java/com/hopwork/validation/registration/number/CifValidator.java)
 */
export function cifValidator(value: string): boolean {
    const STARTING_LETTERS = /^[ABCDEFGHJNPQRSUVW]/;
    const CIF_PATTERN = /^[ABCDEFGHJNPQRSUVW]\d{7}[\dA-J]$/;

    function isValidCif(cif: string): boolean {
        if (cif == null || cif.length !== 9) {
            return false;
        }

        const cifLetter = cif.substring(0, 1);

        if (!cifLetter.match(STARTING_LETTERS)) {
            return false;
        }

        const cifDigits = cif.substring(1, cif.length - 1);

        let digit: number;
        const computeDigit = computeControlDigit(cifDigits);
        if (computeDigit != null) {
            digit = computeDigit;
        } else {
            return false;
        }

        const cifControlCharacter = cif.substring(cif.length - 1);

        if (cifLetter.match(/[ABEH]/)) {
            return digit.toString().toLowerCase() === cifControlCharacter.toLowerCase();
        }
        const letters = ['J', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I'];
        const isValidControl = letters[digit]?.toLowerCase() === cifControlCharacter?.toLowerCase();

        return cifLetter.match(/[NPQRSW]/) ? isValidControl : digit.toString().toLowerCase() === cifControlCharacter.toLowerCase() || isValidControl;
    }

    function computeControlDigit(cifDigits: string): number | null {
        let sum = 0;
        let digit: number;

        for (let i = 0; i < cifDigits.length; i++) {
            digit = parseInt(cifDigits.charAt(i).toString());

            if (!cifDigits.match(/\d+/)) {
                return null;
            }

            if (i % 2 === 0) {
                digit *= 2;
                if (digit > 9) {
                    digit = Math.trunc(digit / 10 + (digit % 10));
                }

                sum += digit;
            } else {
                sum += digit;
            }
        }

        sum %= 10;
        return sum !== 0 ? 10 - sum : sum;
    }

    return !!value.match(CIF_PATTERN) && isValidCif(value);
}
